export const setQueryParam = (name, value) => {
  const existingParams = new URLSearchParams(window.location.search);
  existingParams.set(name, value);
  const newUrl = `${window.location.pathname}?${existingParams.toString()}`;
  window.history.replaceState(null, '', newUrl);
}

export const getQueryParam = (name) => {
  const existingParams = new URLSearchParams(window.location.search);
  const param = existingParams.get(name);
  if(param){
    return param;
  }
}

export const deleteQueryParam = (name) => {
  const params = new URLSearchParams(window.location.search);
  params.delete(name);
  applyUrlChange(params);
}

export const clearAllFilterParams = (paramNames) => {
  const params = new URLSearchParams(window.location.search);
  paramNames.forEach(name => params.delete(name));
  applyUrlChange(params);
}

const applyUrlChange = (params) => {
  const qs = params.toString();
  const newUrl = qs
    ? `${window.location.pathname}?${qs}`
    : window.location.pathname;
  window.history.replaceState(null, '', newUrl);
}

const setOrDelete = (params, name, value) => {
  if (value == null) {
    params.delete(name);
  } else {
    params.set(name, String(value));
  }
}

export const normalizeDifficultyFilterRange = (difficultyFilter) => {
  if (!difficultyFilter) {
    return null;
  }

  const { min, max } = difficultyFilter;

  if (min === 0.25 && max === 0.5) {
    return { min: 0.26, max: 0.5 };
  }

  if (min === 0.5 && max === 0.75) {
    return { min: 0.51, max: 0.75 };
  }

  if (min === 0.75 && max === 1) {
    return { min: 0.76, max: 1 };
  }

  return difficultyFilter;
}

export const parseDifficultyFilterFromUrl = (difficulty) => {
  if (!difficulty) {
    return null;
  }

  const parts = difficulty.split(',');
  const min = Number.parseFloat(parts[0]);
  const max = Number.parseFloat(parts[1]);

  if (Number.isNaN(min) || Number.isNaN(max) || min < 0 || max > 1 || min > max) {
    return null;
  }

  return normalizeDifficultyFilterRange({ min, max });
}

export const syncFiltersToUrl = ({ sportType, mapView, filters }) => {
  const params = new URLSearchParams(window.location.search);

  setOrDelete(params, 'type', sportType || null);
  setOrDelete(params, 'view', mapView ? 'true' : null);

  const defaultGroupIds = { mountainbike: 1933, run: 12045, horseback: 16185 };
  const catFilter = filters.categoryFilter;
  const isNonDefaultCategory = catFilter != null && catFilter !== defaultGroupIds[sportType];
  setOrDelete(params, 'typeroute', isNonDefaultCategory ? catFilter : null);

  const defaultMaxLength = { mountainbike: 200, run: 50 };
  const maxLen = defaultMaxLength[sportType] || 200;
  const hasCustomLength = filters.lengthFilter &&
    (filters.lengthFilter.min !== 0 || filters.lengthFilter.max !== maxLen);
  setOrDelete(params, 'length',
    hasCustomLength ? `${filters.lengthFilter.min},${filters.lengthFilter.max}` : null);

  setOrDelete(params, 'paved', filters.pavedFilter ?? null);

  const normalizedDifficultyFilter = normalizeDifficultyFilterRange(filters.difficultyFilter);
  const hasCustomDifficulty = normalizedDifficultyFilter &&
    (normalizedDifficultyFilter.min !== 0 || normalizedDifficultyFilter.max !== 1);
  setOrDelete(params, 'difficulty',
    hasCustomDifficulty ? `${normalizedDifficultyFilter.min},${normalizedDifficultyFilter.max}` : null);

  applyUrlChange(params);
}

export const readFiltersFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  const get = (name) => params.get(name) || null;
  return {
    type: get('type'),
    view: get('view'),
    typeroute: get('typeroute'),
    length: get('length'),
    paved: get('paved'),
    difficulty: get('difficulty'),
    combo: get('combo'),
    location: get('location'),
    province: get('province'),
    lat: get('lat'),
    lng: get('lng'),
    zoom: get('zoom'),
  };
}

export const scoreToOutOfFive = (percentage) => {
  if(percentage === undefined || percentage === null){
    return 0
  }

  return (Number(percentage) * 5).toFixed(1)
}

export const navigateToDetail = (id, window, redirectRoute) => {
  if (
    window &&
    window.location &&
    window.location.href &&
    window.location.pathname !== redirectRoute
  ) {
    window.location.href = buildDetailUrl(id, window, redirectRoute);
  }
}

export const buildDetailUrl = (id, win, redirectRoute) => {
  try {
    if (!win || !win.location) return `${redirectRoute}${id}/`;
    const existingParams = new URLSearchParams(win.location.search);
    const qs = existingParams.toString();
    return `${redirectRoute}${id}/` + (qs ? `?${qs}` : '');
  } catch {
    return `${redirectRoute}${id}/`;
  }
}